import { format } from 'date-fns';

import { dateFormat } from 'constants/formats';
import { TranslateFn } from 'hooks/useTranslate';
import {
  IncentiveOfferOperation,
  IncentiveOfferType,
  IncentivesMarketBeneficiary,
} from 'modules/incentivesMarket/types';

import { getFullAddress } from 'utils/filters';
import { statusBadgeMap } from '../../../constants/incentiveOfferOperationStatus';
import getOperationReference from '../../../utils/getOperationReference';

const getParticipantName = (
  participant: string | Partial<IncentivesMarketBeneficiary>
) => {
  if (typeof participant === 'string') return participant;
  return participant?.name || '';
};

export const buildIncentiveOfferOperationsXlsxData = ({
  operations,
  offerType,
  t,
}: {
  operations: IncentiveOfferOperation[];
  offerType: IncentiveOfferType;
  t: TranslateFn;
}) => {
  const isBuyOffer = offerType === IncentiveOfferType.BUY;
  const participantLabel = t(isBuyOffer ? 'Seller' : 'Buyer');

  return (operations || []).map((operation, index) => {
    const badge = statusBadgeMap[operation.status] || {
      label: operation.status,
    };

    const participant = isBuyOffer
      ? (operation.seller as Partial<IncentivesMarketBeneficiary>)
      : (operation.buyer as Partial<IncentivesMarketBeneficiary>);

    return {
      '#': index + 1,
      [t('OperationRef')]: getOperationReference(operation),
      [participantLabel]: getParticipantName(participant),
      [t('Cif')]: participant?.cif || '',
      [t('Email')]: participant?.email || '',
      [t('Phone')]: participant?.phone || '',
      [t('Address')]: getFullAddress(participant?.address) || '',
      [t('BankAccountNumber')]: participant?.bankAccountNumber || '',
      [t('IncentivesMarketUnits')]: operation.unitsCount,
      [t('OfferAmount')]: operation.offerAmount,
      [t('Amount')]: operation.totalPrice,
      [t('Date')]: format(new Date(operation.requestDate), dateFormat),
      [t('Status')]: t(badge.label),
    };
  });
};
